import env from "../../../env";
export default {
  namespaced: true,
  state: {
    logSSOUrl:
      `${env[process.env.NODE_ENV].loginUrl}/login?service=` +
      encodeURIComponent(
        "https://auth.xkw.com/callback?curl=" +
          encodeURIComponent("https://shopcenter.xkw.com/api/router")
      ),
    logoutSSOUrl:
      `${env[process.env.NODE_ENV].loginUrl}/logout?service=` +
      encodeURIComponent(
        "https://auth.xkw.com/callback?curl=" +
          encodeURIComponent("https://shopcenter.xkw.com")
      ),
  },
};
